import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventData } from './data.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private isAppEmbeddedSubject = new BehaviorSubject<boolean>(false);
  isAppEmbedded$ = this.isAppEmbeddedSubject.asObservable();
  private hasOfferBarSubject = new BehaviorSubject<boolean>(false);
  hasOfferBar$ = this.isAppEmbeddedSubject.asObservable();
  private eventSubject = new BehaviorSubject<EventData>(null);
  eventData$ = this.eventSubject.asObservable();
  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      const isEvent = !!(params?.['isEvent'] === 'true');
      const eventCampaignId = params?.['eventCampaignId'];
      const eventFieldAgentId = params?.['eventFieldAgentId'];

      if(isEvent && eventCampaignId && eventFieldAgentId){
        this.setEventData({
          isEvent,
          eventDetails: {
            eventCampaignId,
            eventFieldAgentId
          }
        });
      }
    });
  }

  navigateToPath(path: string, queryParams?: { [key: string]: any }): void {
    const params = { queryParamsHandling: 'merge' } as NavigationExtras;
    if (queryParams) {
      params['queryParams'] = queryParams;
    }
    this.router.navigate([path], params);
  }

  setIsEmbedded(value: boolean) {
    this.isAppEmbeddedSubject.next(value);
  }

  getIsEmbedded(): Observable<any> {
    return this.isAppEmbeddedSubject.asObservable();
  }
  setHasOfferBar(value: boolean) {
    this.hasOfferBarSubject.next(value);
  }

  getHasOfferBar(): Observable<any> {
    return this.hasOfferBarSubject.asObservable();
  }

  setEventData(value: EventData) {
    this.eventSubject.next(value);
  }

  getEventData(): Observable<any> {
    return this.eventSubject.asObservable();
  }
}
